export const SUPABASE_URL = 'https://ntcwsxuzstbplroxswsr.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im50Y3dzeHV6c3RicGxyb3hzd3NyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODAzNjY0ODIsImV4cCI6MjA5NTk0MjQ4Mn0.7XWcUSXrDAqMo-33JjsBFF4Rg2yMh8bcwpYAT2p-dyw';

// Set VITE_DEBUG_LEADERBOARD=true in .env.local to log submit failures during development.
// Reads false in all production builds (Vite strips unset VITE_* vars to undefined).
export const DEBUG_LEADERBOARD = import.meta.env.VITE_DEBUG_LEADERBOARD === 'true';
